module.exports = __webpack_public_path__ + "media/audio3.6fe0f9ca.mp3";